// 从一段可能包含说明文字的文本中提取第一个 HTTP/HTTPS 链接。
// 遇到中英文逗号、句号、分号、括号、引号等标点即停止匹配，并额外剥离末尾残留标点，
// 避免“https://.../abc123，提取码：1234”这类内容被整段当成网址。
// 保留 URL 内部合法字符（? & = # . - _ ~ 等）。
const TRAILING_URL_PUNCTUATION = /[，。；、！？：,;.!?()[\]{}<>"'“”‘’）】》」』]+$/;

export function extractFirstUrl(text: string): string | null {
  if (!text) return null;
  const match = text.match(/https?:\/\/[^\s<>，。；、！？：（）()【】《》"“”‘’,;]+/i);
  if (!match) return null;
  return match[0].replace(TRAILING_URL_PUNCTUATION, "");
}

// 从网盘分享文字中提取 4 位提取码（“提取码: w9px”“密码：abcd”或链接里的 ?pwd=w9px）。
// 只用于展示；复制给家长的仍是完整原文。识别不到时返回 null。
export function extractShareCode(text: string): string | null {
  if (!text) return null;
  const labeled = text.match(/(?:提取码|提取密码|密码)\s*[:：]?\s*([A-Za-z0-9]{4})(?![A-Za-z0-9])/);
  if (labeled) return labeled[1];
  const fromUrl = text.match(/[?&]pwd=([A-Za-z0-9]{4})(?![A-Za-z0-9])/i);
  return fromUrl ? fromUrl[1] : null;
}
